// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__VgllQ","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__TE-Q3"};